module.exports = __webpack_public_path__ + "assets/media/music-bg.4929d480.mp3";